import {createFileRoute} from "@tanstack/react-router";

/** Path matcher only. The page stays mounted on the parent layout route. */
function ConfigPagePathMatch() {
    return null;
}

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_configScaffold/$pageKey/",
)({
    component: ConfigPagePathMatch,
});
